module.exports = __webpack_public_path__ + "static/media/total.3621bfcf.svg";